import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status", "friendButton", "fallbackLink"]
  static values = {
    liffId: String,
    source: String,
    campaign: String,
    friendUrl: String
  }

  async connect() {
    this.attributionSaved = false

    try {
      await window.liff.init({ liffId: this.liffIdValue })
      if (!window.liff.isLoggedIn()) {
        window.liff.login()
        return
      }

      const idToken = window.liff.getIDToken()
      if (!idToken) throw new Error("LINE ID token is unavailable")

      const query = new URLSearchParams(window.location.search)
      const response = await fetch("/line/attribution", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
        },
        body: JSON.stringify({
          id_token: idToken,
          source: query.get("source") || this.sourceValue,
          campaign: query.get("campaign") || this.campaignValue
        })
      })
      if (!response.ok) throw new Error("Attribution could not be saved")

      this.attributionSaved = true
      if (!window.liff.isInClient()) {
        this.showFallback()
        return
      }

      this.statusTarget.textContent = "確認できました。次のボタンから友だち追加してください。"
      this.friendButtonTarget.classList.remove("hidden")
    } catch (_error) {
      this.showFallback()
    }
  }

  async requestFriendship() {
    try {
      if (typeof window.liff.requestFriendship !== "function") {
        this.showFallback()
        return
      }

      await window.liff.requestFriendship()
      this.statusTarget.textContent = "友だち追加画面を確認しました。LINEでReci-Botを開いてください。"
      this.friendButtonTarget.classList.add("hidden")
      this.fallbackLinkTarget.textContent = "LINEでReci-Botを開く"
      this.fallbackLinkTarget.classList.remove("hidden")
    } catch (_error) {
      this.showFallback()
    }
  }

  showFallback() {
    this.statusTarget.textContent = this.attributionSaved
      ? "流入元を記録しました。次のリンクからReci-Botを友だち追加してください。"
      : "LINEで確認できなかったため、通常の友だち追加画面を開いてください。流入元はdirectとして記録されます。"
    this.friendButtonTarget.classList.add("hidden")
    this.fallbackLinkTarget.textContent = "LINEで友だち追加"
    this.fallbackLinkTarget.classList.remove("hidden")
  }
}
